import React, {useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material/';
import { getConsentement ,setConsentement } from '../../utils/userRule';

export default function Dialog_consentement({ onAnswer,onClose }) {
  
  
  const [Open, setOpen] = useState(false);
  
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
      headers: { Authorization: "Bearer "+ Cookies.get('token'),
              }      
})



    useEffect(() => {

      
      if(getConsentement() === false)
         setOpen(true);

    });




  function handleAnswer(response)
  {   
   
      MyAxios.post(process.env.REACT_APP_API + '/con/setReponse/' + response)              
      .then((res) => {       
            console.log(res)
            if(res.status === 200)    
            {
                //alert("Sauvegarde complété");
                setOpen(false);
            }   
            else 
            {     
               // alert("Erreur sauvegarde");
            }  
            
        })
        .catch((error) => {
            console.log(error)
            //alert("Erreur sauvegarde")
        });


      if(response === true)  
      {   
              setConsentement("oui");    
      }
      else  
      {
       // setConsentement("non");
        Cookies.set('token',  "" , {secure: true, sameSite: 'none'});             
        Cookies.set('useremail',  "");    
        //window.location.reload();
        setOpen(false);
        window.location.href = process.env.REACT_APP_FRONTEND_UI + "";

      }



      
     

  }


  
  return (
    <Dialog open={Open} onClose={onClose}>
      <DialogTitle> CONSENTEMENT À L’USAGE DES DONNÉES</DialogTitle>
      <DialogContent>
        <DialogContentText>       
            En tant que dirigeant de groupe Opti-jeunesse, je confirme avoir lu la <a href="https://opti-jeunesse.org/politique-de-confidentialite/" target="_blank" >Politique de confidentialité</a>, 
            la <a href="https://opti-jeunesse.org/protection-des-donnees-personnelles/" target="_blank" >Protection des données personnelles</a> et avoir compris l’information relativement à la collecte des données, 
            à leurs usages et la conservation de nos renseignements. 
            
            Je comprends que les données collectées sur nos sites <a href="https://opti-jeunesse.org/" target="_blank" >opti-jeunesse.org</a> et Dirigeants 
            sont utilisées pour gérer les activités d’Opti-jeunesse, la communication interne, 
            ainsi que pour offrir des avantages ou de services spécifiques aux membres. 
            En aucun moment nos données ne seront partagées avec des tiers.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleAnswer(true)} color="primary">
          Oui
        </Button>
        <Button onClick={() => handleAnswer(false)} color="primary" autoFocus>
          Non
        </Button>
      </DialogActions>
    </Dialog>
  );
}
